module.exports = __webpack_public_path__ + "img/img_jp3.2806da81.jpg";